import React from "react";
import Synonyms from "./Synonyms";
import Antonyms from "./Antonyms";
import "./Meaning.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";

export default function Meaning(props) {
  //recieve props from Results
  //console.log(sprops.meaning);

  return (
    //return list of meanings. To see what are in a list check it out here - console.log(props.meaning.definitions);
    <div className="Meaning mb-3 ">
      <h4>{props.meaning.partOfSpeech}</h4>

      {props.meaning.definitions.map(function (definition, index) {
        if (definition.example) {
          //if example exist - show with example, if not -show without
          return (
            //mapping description list
            <div key={index} className="ps-3">
              <p className="definition">
                <FontAwesomeIcon icon={faArrowRight} /> {definition.definition}
              </p>
              <p className="example">
                <em>
                  <b>e. g.</b> {definition.example}
                </em>
              </p>
            </div>
          );
        } else {
          return (
            //mapping description list
            <div key={index} className="ps-3">
              <p>
                <FontAwesomeIcon icon={faArrowRight} /> {definition.definition}
              </p>
            </div>
          );
        }
      })}
      <Synonyms synonyms={props.meaning.synonyms} />
      <Antonyms antonyms={props.meaning.antonyms} />
    </div>
  );
}
